import React, { Fragment, useEffect, useState } from "react";
import { cdnImg } from "../../../Utils/cdnImage";
import HeaderWeb from "../Account/HeaderWeb";
import HomeLeft from "./HomeLeft";
import HomeRight from "./HomeRight";
import { useLocation } from "react-router-dom";
import BetSlipContext from "../../../context/BetSlipContext";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../../../context/AuthContext";

const WebSkyLayout = ({ eventName, gameType, seriesName, children }) => {
  const location = useLocation();
  const betLoader = useContextSelector(AuthContext, (ctx) => {
    return ctx.betLoader;
  });
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => {
      setLoading(false);
    }, 500); // adjust duration

    return () => clearTimeout(timer);
  }, [location]); // ⚡ use location.key instead of pathname
  return (
    <Fragment>
      <HeaderWeb />
      <div className="full-wrap">
          {betLoader && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              height: "100vh",
              width: "100vw",
              backgroundColor: "transparent",
              zIndex: 9999,
              cursor: "not-allowed",
            }}
          />
        )}
        {(betLoader || loading) && (
          <div
            id="loading"
            className="loading-wrap"
            style={{ top: "260px", display: "block" }}
          >
            <ul className="loading">
              <li>
                <img src={cdnImg("/assets/images/loading40.gif")} />
              </li>
              <li>Loading...</li>
              <br />
              <li>
                <span id="progress" />
              </li>
            </ul>
          </div>
        )}
        {location?.pathname?.split("/")[1] !== "inplay-sky" && (
          <HomeLeft
            eventName={eventName}
            gameType={gameType}
            seriesName={seriesName}
          />
        )}
        {children} <HomeRight />
      </div>{" "}
    </Fragment>
  );
};

export default WebSkyLayout;
